import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import * as Yup from "yup";
import { IoMdDownload } from "react-icons/io";
import CustomModal from "../Modal";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";
import { useFormik } from "formik";
import { getCustomerDropdownDataApiCall } from "../../../Api/api";
import CustomDropdown from "../CustomDropdown/CustomDropdown";

const initialValues = {
   startDate: "",
   endDate: "",
};

const validationSchema = Yup.object().shape({
   startDate: Yup.date()
      .required("Start date is required")
      .typeError("Invalid date format"),
   endDate: Yup.date()
      .required("End date is required")
      .typeError("Invalid date format")
      .min(Yup.ref("startDate"), "End date must be later than or equal to Start date"),
});

const DownloadReportButton = ({
   title = "Download Report",
   onDownloadReport,
   confirmPopup,
   needCustomerFilter,
}) => {
   const [customerOptions, setCustomerOptions] = useState([]);

   const hndleCloseDateModal = () => {
      resetForm();
      setFieldValue("customerId", "");
      confirmPopup?.onFalse();
   };

   const handleGetReportData = (formData) => {
      const data = {
         from_date: formData?.startDate,
         to_date: formData?.endDate,
         model_id: 11,
         action_id: 3,
         //  _method: "PATCH",
         ...formData,
      };
      console.log({ formData });
      onDownloadReport &&
         onDownloadReport(data, () => {
            hndleCloseDateModal();
         });
   };

   const getCustomerDropdown = async () => {
      try {
         const res = await getCustomerDropdownDataApiCall();
         const options = res?.data?.res?.map?.((item) => ({
            label: item?.name,
            value: item?.id,
         }));
         setCustomerOptions(options);
         console.log({ res });
      } catch (error) {
         //
      }
   };

   const formik = useFormik({
      initialValues,
      validationSchema,
      enableReinitialize: true,
      onSubmit: handleGetReportData,
   });

   const {
      errors,
      values,
      touched,
      getFieldProps,
      handleSubmit,
      setFieldValue,
      resetForm,
   } = formik;

   useEffect(() => {
      if (needCustomerFilter) {
         getCustomerDropdown();
      }
   }, [needCustomerFilter]);

   return (
      <>
         <CustomModal
            showModal={confirmPopup?.value}
            handleCloseModal={hndleCloseDateModal}
            modalSize="modal-lg"
            modalHeight="80vh"
            title="Choose dates"
            onSubmit={handleSubmit}
            child={
               <div className="row card-body">
                  {needCustomerFilter && (
                     <div className="col-lg-12">
                        <CustomDropdown
                           label="Select Customer"
                           id="#customerId"
                           name="customerId"
                           placeholder="Select Customer"
                           optionData={customerOptions}
                           {...getFieldProps("customerId")}
                           onChange={(values) => {
                              setFieldValue("customerId", values?.[0]?.value);
                           }}
                        />
                     </div>
                  )}
                  <div className="col-lg-6">
                     <CustomDatePicker
                        require
                        label="Start date"
                        placeholder="Enter start date"
                        {...getFieldProps("startDate")}
                        errors={Boolean(touched.startDate) && Boolean(errors.startDate)}
                        message={errors.startDate}
                     />
                  </div>
                  <div className="col-lg-6">
                     <CustomDatePicker
                        require
                        label="End date"
                        placeholder="Enter end date"
                        {...getFieldProps("endDate")}
                        errors={Boolean(touched.endDate) && Boolean(errors.endDate)}
                        message={errors.endDate}
                     />
                  </div>
               </div>
            }
         />

         <Box>
            <Button
               variant="outlined"
               startIcon={<IoMdDownload />}
               onClick={confirmPopup?.onTrue}
            >
               {title}
            </Button>
         </Box>
      </>
   );
};

export default DownloadReportButton;
